const initState = {
  isFetching: false,
  authError: null,
  userInfos: null,
};

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "DOING_LOGIN":
      return {
        ...state,
        isFetching: true,
      };

    case "LOGIN_SUCCESS":
      return {
        ...state,
        isFetching: false,
        authError: null,
      };

    case "LOGIN_FAILED":
      return {
        ...state,
        isFetching: false,
        authError: "Login Failed",
      };

    case "SUBSCRIBE_LOGIN":
      return {
        ...state,
        isFetching: true,
      };

    case "SUBSCRIBE_SUCCESS":
      return {
        ...state,
        isFetching: false,
        authError: null,
      };

    case "SUBSCRIBE_FAILED":
      return {
        ...state,
        isFetching: false,
        authError: "Login Failed",
      };

    case "DOING_LOGOUT":
      return {
        ...state,
        isFetching: true,
      };

    case "LOGOUT_SUCCESS":
      return {
        ...state,
        isFetching: false,
        authError: null,
      };

    case "LOGOUT_FAILED":
      return {
        ...state,
        isFetching: false,
        authError: "Login Failed",
      };

    case "SET_USER_INFOS":
      return {
        ...state,
        userInfos: action.payload,
        isFetching: false,
        authError: null,
      };
    case "SET_USER_INFOS_JWT":
      return {
        ...state,
        userInfos: {
          ...state.userInfos,
          jwt: action.payload,
        },
      };

    default:
      return state;
  }
};

export default authReducer;
